import React, { useState, useEffect, useRef } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../../layout/header";
import Footer from "../../layout/footer";
import moment from "moment";
import LinesEllipsis from "react-lines-ellipsis";

import Loading from "../../components/loading";
import backIcon from "../../assets/img/icon/back.svg";
// import nextIcon from "../../assets/img/icon/sorn.svg";

// import Slider from "react-slick";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";

import { getData } from "../../services/getService";
import Modalgallery from "../../components/modalSrc";

import Select4SepEd from "../../components/4selectSepED";
import Select4SepEd2025 from "../../components/4selectSepED2025";
import Select4Sep4School from "../../components/4selectSep4School";
import Select4Sep4School2025 from "../../components/4selectSep4School2025";
import Select4SepCamp from "../../components/4selectSepCamp";
import Select4SepCamp2025 from "../../components/4selectSepCamp2025";

import { importAllImages } from "../../utils/importImages";

const CentresOverview = () => {
  const pr = useParams();

  const galleryContext5 = require.context(
    "../../assets/img/07-2025/archives/seped",
    false,
    /\.(png|jpe?g|svg)$/i
  );

  const galleryContext6 = require.context(
    "../../assets/img/07-2025/archives/sep4school",
    false,
    /\.(png|jpe?g|svg)$/i
  );
  const galleryContext7 = require.context(
    "../../assets/img/07-2025/archives/camp4",
    false,
    /\.(png|jpe?g|svg)$/i
  );

  const galleryContext8 = require.context(
    "../../assets/img/02-2025/gallery",
    false,
    /\.(png|jpe?g|svg)$/i
  );

  const galleryContext9 = require.context(
    "../../assets/img/07-2025/gallery/camp",
    false,
    /\.(png|jpe?g|svg)$/i
  );

  const galleryContext10 = require.context(
    "../../assets/img/07-2025/gallery/sep4school",
    false,
    /\.(png|jpe?g|svg)$/i
  );

  // const pr = useParams();
  const gel = importAllImages(
    pr.id === "5"
      ? galleryContext5
      : pr.id === "6"
      ? galleryContext6
      : pr.id === "7"
      ? galleryContext7
      : pr.id === "8"
      ? galleryContext8
      : pr.id === "9"
      ? galleryContext9
      : pr.id === "10"
      ? galleryContext10
      : null
  );

  const [isLoading, setIsLoading] = useState(true);
  const [dataOne, setDataOne] = useState({});
  const [mainData, setMainData] = useState({ photo: gel });
  const [dataThree, setDataThree] = useState([]);

  const called = useRef(true);

  const [modalgallery, setModalgallery] = useState({ view: false });

  // const [mainData, setMainData] = useState({ photo: gel });

  useEffect(() => {
    if (called.current) {
      Promise.all([fetchDataOne()]).then((res) => {
        setIsLoading(false);
      });
    }
    return () => {
      called.current = false;
    };
  }, []);

  const fetchDataOne = async () => {
    getData("vinformation", pr.id)
      .then((response) => {
        if (response.status === "success") {
          setDataOne(response.data);
          fetchDataThree(response.data.catId);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  const fetchDataThree = async (catId) => {
    var iid;
    if (catId === "virtual") {
      iid = "previous";
    } else {
      iid = catId;
    }
    getData("pageawards", iid)
      .then((response) => {
        if (response.status === "success") {
          setDataThree(response.data);
        }
      })
      .catch((e) => {
        console.log(e.response.data.error);
      });
  };

  const youtubeEmbed = (id) => {
    const videoMap = {
      5: "https://www.youtube.com/embed/ORv1bRQBYSY?si=svMgZb39x3ouYLBr",
      6: "https://www.youtube.com/embed/rRtFLTq5MQI?si=P2cs_H8mO72qYveG",
      7: "https://www.youtube.com/embed/ywpk46A7xo0?si=F8-KiVO4bwbPLzCo",
      8: "https://www.youtube.com/embed/m_OW5psWlkc?si=gn7rS7hZwNw0iYkp",
      9: "https://www.youtube.com/embed/tEZYGesfUlA?si=fCysX-DbhB0iWnf-",
      10: "https://www.youtube.com/embed/tEZYGesfUlA?si=jxAQEYRMscju5F5O",
    };

    return videoMap[id] || videoMap["default"];
  };

  return (
    <>
      <div id="outer-container" style={{}}>
        <Header page="news" sub="archives" />
        <div className="wrapper bg-white box-index">
          {isLoading ? <Loading /> : null}
          <section className="my-5" id="page-wrap">
            <div className="container-fluid">
              <div className="row justify-content-center text-start">
                <div className="col-12 col-md-12 col-lg-10">
                  {dataOne ? (
                    <>
                      <div className="px-3 px-md-3 px-lg-5">
                        <div className="row align-items-center mb-3 mb-md-5 mt-lg-5">
                          <div className="col-12 col-md-12 col-lg-12">
                            <div className="font-60 weight-700 yellow-black">
                              Archives
                            </div>
                          </div>
                          <div className="col-12 col-md-12 col-lg-10">
                            <div className="">
                              <span className="">
                                Programmes and Activities
                              </span>
                              |<span className="">Capacity Building </span>|
                              <span className="text-decoration-underline">
                                {dataOne.name + " " + dataOne.year}
                              </span>
                            </div>
                          </div>
                          <div className="col-12 col-md-12 col-lg-2 text-end">
                            <div className="">
                              <Link
                                to="/newsandgallery/archives"
                                className="btn btn-back ps-0 weight-700"
                              >
                                <img
                                  src={backIcon}
                                  style={{ width: "30px" }}
                                  alt=""
                                />{" "}
                                Back
                              </Link>
                            </div>
                          </div>
                          <div className="col-12 col-md-12 col-lg-12">
                            <div className="mt-3">
                              {/* <div className="font-32 weight-700"> */}
                              {/* {mainData.topic} */}
                              <div
                                className="topic weight-700"
                                dangerouslySetInnerHTML={{
                                  __html: dataOne.name,
                                }}
                              />
                              {/* </div> */}
                              {/* <div className="font-14 mt-2">
                                                                {moment(mainData.dateActive).format("D/MM/Y")}
                                                            </div> */}
                            </div>
                          </div>

                          <div className="col-12 col-md-12 col-lg-12">
                            <div className="">
                              <div className="pt-4">
                                {dataOne.img ? (
                                  <img
                                    src={
                                      process.env.REACT_APP_IMG_LINK +
                                      "/uploads/vinformation/" +
                                      dataOne.id +
                                      "/" +
                                      dataOne.img
                                    }
                                    className="w-100 rounded"
                                    alt=""
                                  />
                                ) : (
                                  <div
                                    style={{
                                      background: "#D9D9D9",
                                      height: "400px",
                                    }}
                                  ></div>
                                )}
                              </div>
                              <div
                                className="font-18 text-justify content-custom pt-4"
                                dangerouslySetInnerHTML={{
                                  __html: dataOne.detail,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
              <div className="row justify-content-center pb-md-5 text-start">
                <div className="col-12 col-md-12 col-lg-9">
                  {pr.id === "5" ? (
                    <Select4SepEd />
                  ) : pr.id === "6" ? (
                    <Select4Sep4School />
                  ) : pr.id === "7" ? (
                    <Select4SepCamp />
                  ) : pr.id === "8" ? (
                    <Select4SepEd2025 />
                  ) : pr.id === "9" ? (
                    <Select4SepCamp2025 />
                  ) : pr.id === "10" ? (
                    <Select4Sep4School2025 />
                  ) : null}
                  <div className="row justify-content-center pb-md-5 pt-md-5 mt-5 text-start">
                    <div className="col-12 col-md-8 col-lg-8">
                      <div className="d-none d-md-block">
                        <iframe
                          width="100%"
                          height="515"
                          src={youtubeEmbed(pr.id)}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                      <div className="d-block d-md-none">
                        <iframe
                          width="100%"
                          height="210"
                          src={youtubeEmbed(pr.id)}
                          title="YouTube video player"
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          referrerPolicy="strict-origin-when-cross-origin"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </div>
                  </div>
                  {dataOne.news && dataOne.news.length ? (
                    <div>
                      <div className="topic mb-4 mt-5">News</div>
                      <div className="row">
                        {/* {dataNews.length ? dataNews.sort((a, b) => new Date(b.dateActive) - new Date(a.dateActive)).map((val, index) => ( */}
                        {dataOne.news
                          .sort(
                            (a, b) =>
                              new Date(b.dateActive) - new Date(a.dateActive)
                          )
                          .map((val, index) => (
                            <div
                              className="col-12 col-md-4 col-lg-4"
                              key={index}
                            >
                              <Link
                                to={"/newsandgallery/news/" + val.newsId}
                                className="a-news pb-4 mb-4 mb-md-5"
                              >
                                <div className="row text-start">
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div>
                                      <img
                                        src={
                                          process.env.REACT_APP_IMG_LINK +
                                          "/uploads/news/" +
                                          val.newsId +
                                          "/" +
                                          val.banner
                                        }
                                        className="w-100 rounded"
                                        alt=""
                                      />
                                    </div>
                                  </div>
                                  <div className="col-12 col-md-12 col-lg-12">
                                    <div className="font-14 mt-2">
                                      {moment(val.dateActive).format(
                                        "D MMMM Y"
                                      )}
                                    </div>

                                    <div
                                      className="news-topic mt-3 mt-md-0"
                                      dangerouslySetInnerHTML={{
                                        __html: val.topic,
                                      }}
                                    />
                                    {/* <div className="mt-1">
                                                                    <TagView myString={val.tag} />
                                                                </div> */}
                                    <div className="mt-4">
                                      <LinesEllipsis
                                        text={val.subTopic}
                                        maxLine="3"
                                        ellipsis="..."
                                        trimRight
                                        basedOn="letters"
                                      />
                                    </div>
                                    <div className="mt-3">
                                      <span style={{ color: "#e6c12f" }}>
                                        Read More
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Link>
                            </div>
                          ))}
                      </div>
                    </div>
                  ) : null}

                  <div className="topic mb-3">Gallery</div>
                  <div>
                    <div className="d-flex gap-1 gap-md-2">
                      <div
                        className="flex-fill"
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[0],
                            active: 0,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[0]}
                          className="w-100 cursor-pointer h-100 object-fit-cover"
                          style={{ height: "200px", objectFit: "cover" }}
                          alt=""
                        />
                      </div>
                      <div
                        className="flex-fill"
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[1],
                            active: 1,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[1]}
                          className="w-100 cursor-pointer h-100 object-fit-cover"
                          style={{ height: "200px", objectFit: "cover" }}
                          alt=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-1 mt-md-2 mb-5">
                    <div className="d-flex gap-1 gap-md-2">
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[2],
                            active: 2,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[2]}
                          className="w-100 cursor-pointer"
                          alt=""
                        />
                      </div>
                      <div
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[3],
                            active: 3,
                          })
                        }
                      >
                        <img
                          src={mainData.photo[3]}
                          className="w-100 cursor-pointer"
                          alt=""
                        />
                      </div>
                      <div
                        className="cursor-pointer position-relative"
                        onClick={() =>
                          setModalgallery({
                            view: true,
                            gallery: mainData.photo,
                            dataUrl: mainData.photo[4],
                            active: 4,
                          })
                        }
                      >
                        <img src={mainData.photo[4]} className="w-100" alt="" />
                        <div
                          className="position-absolute absolute-center-center w-100 h-100"
                          style={{ background: "rgba(0,0,0,.4)" }}
                        >
                          <h1 className="position-absolute absolute-center-center text-white">
                            +{mainData.photo.length - 5}
                          </h1>
                        </div>
                      </div>
                    </div>
                  </div>
                  {pr.id === "9" ? (
                    <>
                      <div className="topic mb-3">Previous Activities</div>
                      <div className="mb-5">
                        <a
                          href="/newsandgallery/archivesOpacity/7"
                          className="btn btn-watch-passtel font-16 px-5 py-2"
                        >
                          2024
                        </a>
                      </div>
                    </>
                  ) : pr.id === "7" ? (
                    <>
                      <div className="topic mb-3">Previous Activities</div>
                      <div className="mb-5">
                        <a
                          href="/newsandgallery/archivesOpacity/9"
                          className="btn btn-watch-passtel font-16 px-5 py-2"
                        >
                          2025
                        </a>
                      </div>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </section>
          <Footer page="news" sub="news" />
        </div>
      </div>
      {modalgallery.view ? (
        <Modalgallery
          show={modalgallery.view}
          onHide={() => setModalgallery({ view: false })}
          dataUrl={modalgallery.dataUrl}
          gallery={modalgallery.gallery}
          active={modalgallery.active}
        />
      ) : null}
    </>
  );
};

export default CentresOverview;
